export const PENDING_TASK_STATUS = 0;
export const COMPLETED_TASK_STATUS = 1;
